import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import styles from "./styles.css";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";
import H2 from "../../shared/h2";
import { sendCustomGaEvents } from "../../../tracking";
import { vrnEntered, vrnChanged, getReportClicked } from "./tracking";
import InputRegNo from "../../shared/input-reg-no";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const CarServiceHistoryRegNo = ({
    isLoading = false,
    isModal = false,
    history,
    regNo,
    setRegNoConnect = () => {},
    handleClick = () => {}
}) => {
    const [registrationNumber, setRegistrationNumber] = useState(regNo || "");
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (isModal) setRegistrationNumber("");
    }, [isModal]);

    const registrationNumberValidator = (v) => {
        return isValidRegistrationNo(v.replace(/\s/g, ""));
    };

    const handleOnChange = (sanitizedValue) => {
        setRegistrationNumber(sanitizedValue.replace(/ /g, ""));
        setIsError(false);
    };

    const onClick = async () => {
        if (!isModal) {
            await yieldToMain();
            sendCustomGaEvents({
                ...getReportClicked,
                eventLabel: registrationNumber
            });
        }
        if (registrationNumberValidator(registrationNumber)) {
            setIsError(false);
            setRegNoConnect(registrationNumber);
            if (isModal) {
                await yieldToMain();
                sendCustomGaEvents({
                    ...vrnChanged,
                    eventLabel: registrationNumber
                });
                handleClick(registrationNumber);
            } else {
                await yieldToMain();
                sendCustomGaEvents({
                    ...vrnEntered,
                    eventLabel: registrationNumber
                });
                await yieldToMain();
                history.push("/car-service-history-info");
            }
        } else {
            setIsError(true);
        }
    };

    const onFocus = () => {
        setIsError(false);
    };

    return (
        <div styleName={`styles.bannerWrapper`}>
            <H2 text="Enter vehicle number" />
            <div styleName={`styles.registrationWrapper`}>
                <InputRegNo
                    value={registrationNumber}
                    onChange={handleOnChange}
                    validator={registrationNumberValidator}
                    errorMessage={"Please enter valid registraton no."}
                    autoCapitalize={"characters"}
                    isError={isError}
                    disableOnChangeError={true}
                    onFocusCallback={onFocus}
                />
                <Button
                    text={isModal ? "Update" : "Get Report"}
                    onClick = {onClick}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

CarServiceHistoryRegNo.propTypes = {
    isLoading: PropTypes.bool,
    isModal: PropTypes.bool,
    history: PropTypes.object,
    regNo: PropTypes.string,
    setRegNoConnect: PropTypes.func,
    handleClick: PropTypes.func
};

export default CarServiceHistoryRegNo;

